import IToken from "../dto/IToken";
import Mapper from "./Mapper";
import store from "@/app/store";
import {Api} from "@/module/api";
import {ICommunicationError} from "@dev/hc-talk-talk";
import {IEnvSettings} from "@/module/main";
import OrderType from "@/module/main/dto/OrderTypeEnum";
import LoginType from "@/module/api/service/LoginTypeEnum";
import FinancedSubjectType from "@/module/main/dto/FinancedSubjectTypeEnum";

class Login {
    public login(envSettings: IEnvSettings): Promise<IToken>
    {
        return new Promise((resolve, reject) =>
        {
            let loginUrlSuffix: LoginType = (envSettings.financedSubjectType === FinancedSubjectType.ORDER && envSettings.orderType === OrderType.CAR_LOAN)
                ? LoginType.APPLICATION : LoginType.PARTNER;

            Api.login(Mapper.toLoginRequest(envSettings), envSettings.envType, envSettings.getEnvValue(), loginUrlSuffix)
                .then((response: any) =>
                {
                    let token: IToken = Mapper.fromLoginResponse(response);
                    store.dispatch("main/setAccessToken", token);
                    resolve(token);
                })
                .catch((error: ICommunicationError) =>
                {
                    reject(error);
                });
        });
    }
}

export default new Login();
